import { render, staticRenderFns } from "./sidebarRightSide.vue?vue&type=template&id=9f91a8e2&scoped=true&"
import script from "./sidebarRightSide.vue?vue&type=script&lang=js&"
export * from "./sidebarRightSide.vue?vue&type=script&lang=js&"
import style0 from "./sidebarRightSide.vue?vue&type=style&index=0&id=9f91a8e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f91a8e2",
  null
  
)

export default component.exports